module.exports = __webpack_public_path__ + "img/buy.d2e00641.svg";